// extracted by mini-css-extract-plugin
export default {"btnGoogle":"GoogleLoginButton_btnGoogle__kLlgm","icon":"GoogleLoginButton_icon__QpNbj"};